import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { getOptInReducer } from './store/optin-in.reducer';
import { OptInEffects } from './store/opt-in.effects';

@NgModule({
  imports: [StoreModule.forFeature('optIn', getOptInReducer), EffectsModule.forFeature([OptInEffects])],
  exports: [StoreModule, EffectsModule],
})
export class OptInNgrxModule {}
